// konnektive-core config adapter (1.5.1).
//
// konnektive-core 0.4 funnels (complexionmd, trycomplexionmd, avinolpm) ship
// an OPconfig in a different shape:
//
//   packages[] { productID, campaignID, ids: [{ id }], isTrial, price, ... }
//   upsells[]  { productID, campaignID, voidMain }
//
// init() runs every config through adaptCoreConfig() before anything reads it.
// A core config gets the konnektive-one keys added in memory, so the engine
// reads products[] / *_konnektive as it does for every other funnel:
//
//   packages[i].productID   -> products[i].pid_konnektive
//   packages[i].campaignID  -> products[i].campaignID_konnektive
//   packages[i].ids[n].id   -> products[i].subscribeIds_konnektive[n]
//   upsells[i].productID    -> upsells[i].pid_konnektive
//   upsells[i].campaignID   -> upsells[i].campaignID_konnektive
//
// Additive only: every core key stays where it was. Core page scripts read
// getConfig().packages[...] directly (setPrices, initTotalBox, the coupon
// check), so packages[] is left exactly as the funnel wrote it.
//
// Every other top-level key core funnels use (discountSubscribe,
// international, servicePhone, couponMessage, termsData, companyName,
// productName, gifts) already has the same name in konnektive-one.
//
// A config that is not core format — anything with products[], or without
// packages[] — is returned as the SAME object, untouched. That is the 1.5.1
// no-change guarantee for existing funnels.

export function isCoreConfig(settings) {
	return Boolean(settings)
		&& Array.isArray(settings.packages)
		&& !Array.isArray(settings.products);
}

// Core writes the subscription ids as [{ id: 889 }, ...]. Kept in order: the
// position is what #cBillSubscribeIndex selects. A placeholder 0 stays 0 —
// the order path refuses it rather than this adapter hiding it.
function subscribeIds(ids) {
	return ids.map((entry) => ((entry && typeof entry === 'object') ? entry.id : entry));
}

function withKonnektiveIds(entry) {
	if (!entry || typeof entry !== 'object') {
		return entry;
	}
	const out = { ...entry };
	if (entry.productID !== undefined) {
		out.pid_konnektive = entry.productID;
	}
	if (entry.campaignID !== undefined) {
		out.campaignID_konnektive = entry.campaignID;
	}
	return out;
}

function packageToProduct(pkg) {
	const product = withKonnektiveIds(pkg);
	if (pkg && Array.isArray(pkg.ids)) {
		product.subscribeIds_konnektive = subscribeIds(pkg.ids);
	}
	return product;
}

export function adaptCoreConfig(settings) {
	if (!isCoreConfig(settings)) {
		return settings;
	}

	const adapted = {
		...settings,
		products: settings.packages.map(packageToProduct),
		// Lets render() add the core-only #cBillSubscribeIndex field without
		// touching the DOM of any other funnel.
		coreConfig: true,
	};
	if (Array.isArray(settings.upsells)) {
		adapted.upsells = settings.upsells.map(withKonnektiveIds);
	}
	if (Array.isArray(settings.shipProtection)) {
		adapted.shipProtection = settings.shipProtection.map(withKonnektiveIds);
	}
	return adapted;
}
